import React from 'react'
import _ from 'lodash'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import LtsTextArea from '../../../components/lottus/lts-text-area'
import { InputText } from 'primereact/inputtext'
import { Checkbox } from 'primereact/checkbox'
import { getMessage } from '../../../utils/index'
import { TIPOS, FORMATOS } from '../constants'
import { isCriterioRemessaFinanceira } from '../criterioRemessa'
import ValidarCriterioRemessa from './ValidarCriterioRemessa'
import './CrudIntegracaoForm.scss'

// O critério da remessa não gera requisição, então Formato e Requisição não significam nada nele —
// o backend preenche o formato sozinho (PHOENIX-943).
export const CrudIntegracaoForm = ({ record, changeHandler, messages, setField }) => {
  const criterioRemessa = isCriterioRemessaFinanceira(record)
  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <div className="card card-w-title">
          <h3>
            {getMessage(messages, 'crudIntegracao.label.integracao')} {record.oid || ''}
          </h3>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
              <span className="p-float-label">
                <InputText value={record.nome} onChange={changeHandler} name="nome" />
                <label>{getMessage(messages, 'crudIntegracao.label.nome')}</label>
              </span>
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
              <LtsDropdownUnidade
                name={'unidade'}
                label={getMessage(messages, 'crudIntegracao.label.unidade')}
                value={record.unidade}
                onChange={(e) => setField('unidade', e)}
                showOptionAll={false}
              />
            </div>
          </div>

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
              <LtsDropdownIdValue
                name={'tipo'}
                value={record.tipo}
                onChange={(e) => setField('tipo', e)}
                options={TIPOS}
                label={getMessage(messages, 'crudIntegracao.label.tipo')}
              />
            </div>
          </div>

          {/* Estado do cadastro, não conteúdo: fica junto de Nome/Unidade/Tipo. No fim do form ele
              encostava no texto de ajuda do critério e passava a ser lido como parte do exemplo.
              No critério da remessa a flag decide se a busca aplica o filtro; nos tipos de NFSe é
              só o estado do cadastro. */}
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
              <Checkbox
                checked={record.ativo !== false}
                onChange={(e) => setField('ativo', e.checked)}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label className="label">{getMessage(messages, 'crudIntegracao.label.ativo') || 'Ativo'}</label>
            </div>
          </div>

          {!criterioRemessa && (
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-12 p-md-6 p-lg-5 p-xl-3">
                <LtsDropdownIdValue
                  name={'formato'}
                  value={record.formato}
                  onChange={(e) => setField('formato', e)}
                  options={FORMATOS}
                  label={getMessage(messages, 'crudIntegracao.label.formato')}
                />
              </div>
            </div>
          )}

          <div>
            <br />
            <LtsTextArea
              style={{ minHeight: '200px' }}
              autoFocus={true}
              value={record.consultaSql}
              onChange={(e) => setField('consultaSql', e)}
              name={'consultaSql'}
              label={
                criterioRemessa
                  ? getMessage(messages, 'crudIntegracao.label.criterio') || 'Critério (condição sobre o contrato)'
                  : getMessage(messages, 'crudIntegracao.label.consultaSql')
              }
              cols={100}
            />
            <br />
          </div>

          {criterioRemessa && (
            <ValidarCriterioRemessa
              oidUnidade={_.get(record, 'unidade.id', null)}
              consultaSql={record.consultaSql}
              messages={messages}
            />
          )}

          {!criterioRemessa && (
            <div>
              <LtsTextArea
                style={{ minHeight: '200px' }}
                autoFocus={true}
                value={record.requisicao}
                onChange={(e) => setField('requisicao', e)}
                name={'requisicao'}
                label={getMessage(messages, 'crudIntegracao.label.requisicao')}
                cols={100}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
